import React from 'react';
import {useExecuteModal} from "../../../../../hooks/useExecuteModal";
import {Button, Tooltip} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {FleetExpenseAction, FleetExpensesModel} from "../../../../../models/FleetExpenses/FleetExpensesModel";
import {isFleetExpenseOfType} from "../../config";
import FleetExpenseModal from "../../../../modals/fleetExpenses/FleetExpenseModal/FleetExpenseModal";
import FleetExpensesStore from "../../../../../stores/FleetExpensesStore";

type AddExpenseButtonProps = {
  expense: FleetExpensesModel<'spending-type'> | FleetExpensesModel<'tc'>;
};

const AddExpenseButton = ({ expense }: AddExpenseButtonProps) => {
  const modalHandler = useExecuteModal();
  const onResult: FleetExpenseAction = () => {
    FleetExpensesStore.load({}, true);
  };

  return (
    <>
      <Tooltip placement="top" title={
        `Add ${expense.tc.tc_number}${isFleetExpenseOfType(expense, 'spending-type') ? ` ${expense.spendingType.name}` : ''} expense`
      }>
        <Button style={{ width: '25px', aspectRatio: '1/1' }} type="primary" onClick={modalHandler.executeModal}>
          <PlusOutlined />
        </Button>
      </Tooltip>
      <FleetExpenseModal onResult={onResult} edit={false} expense={expense} store={FleetExpensesStore} handler={modalHandler} />
    </>
  );
};

export default AddExpenseButton;